import 'select2';
import 'select2/dist/css/select2';
import '../../entrypoints/src/admin/jquery_plugins/dynamic_option_select2';

import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    service: String,
    placeholder: String,
    selected: Array
  }

  connect() {
    import(/* webpackMode: "eager" */ `../../entrypoints/src/admin/services/${this.serviceValue}`)
      .then(async ({ default: service }) => {
        this.service = service;
        this.loadSelect2(await this.service.all());
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async loadSelect2(results) {
    $(this.element).select2({
      multiple: true,
      data: results.map((i) => { return { id: i.id, text: i.name } }),
      placeholder: this.placeholderValue || 'Digite para adicionar',
      allowClear: true,
    })
    .val(this.selectedValue)
    .dynamicOption({
      text: '+ Novo Ítem',
      modalTitle: 'Novo Ítem',
      modalLabelName: 'Nome',
      saveItem: async (name, id) => {
        let resource = { [this.element.dataset.objectName]: { name: name } }
        let record = !id ? await this.service.create(resource) : await this.service.update(id, resource);
        return record.id;
      },
      removeItem: async (id) => { return await this.service.destroy(id) },
    });
  }
};